import { useState } from 'react';
import { getAvatarColor } from '../../utils/avatar';

interface AvatarProps {
  name: string;
  url?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  xs: 'w-6 h-6 text-xs',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-xl',
  xl: 'w-24 h-24 text-3xl',
};

export const Avatar = ({
  name,
  url,
  size = 'md',
  className = '',
}: AvatarProps) => {
  const [imageError, setImageError] = useState(false);
  const initial = name ? name.charAt(0).toUpperCase() : '?';
  const colorClass = name ? getAvatarColor(name) : 'bg-gray-400';

  // If URL exists and image hasn't errored, try to show image
  if (url && !imageError) {
    return (
      <img
        src={url}
        alt={name}
        onError={() => setImageError(true)}
        className={`${sizeClasses[size]} rounded-full object-cover border border-gray-200 ${className}`}
      />
    );
  }

  // Fallback to initial if no URL or image failed to load
  return (
    <div
      className={`${sizeClasses[size]} rounded-full ${colorClass} text-white flex items-center justify-center font-bold border border-white/20 shadow-sm ${className}`}
    >
      {initial}
    </div>
  );
};
